import ReactMarkdown from 'react-markdown'

type MarkdownContentProps = {
  children: string
  className?: string
}

/** Safe Markdown for AI Assist replies (no raw HTML). */
export function MarkdownContent({ children, className }: MarkdownContentProps) {
  return (
    <div className={className ? `ai-assist__md ${className}` : 'ai-assist__md'}>
      <ReactMarkdown
        components={{
          a: ({ href, children: linkChildren }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {linkChildren}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}
